
export const setVariables = () => {
    console.log("variables borradas");
    const defaultApiPath = "https://promotoria.eurekamx.com";
    const webOrigin = typeof window !== "undefined" && window.location?.origin ? window.location.origin : null;
    const webHostname = typeof window !== "undefined" && window.location?.hostname ? window.location.hostname : "";
    const isLocalWeb = webHostname === "localhost" || webHostname === "127.0.0.1";
    global.versionApp = "3.2.6w"
    global.gApiPath = isLocalWeb ? "" : (webOrigin || defaultApiPath)
    global.sessionInactiva = 15;
    global.pooleoDistanciaTienda = 5;
    //global.gApiPath = "http:/34.16.150.180:9090" 
    global.gApiPathFoto = global.gApiPath + "/api/imagenPromo?archivo=" 
    global.gApiPathFotoUpc = global.gApiPath +"/api/imagenUPC?archivo="
    global.gUsuario = "";
    global.gIdUsuario = "";
    global.gToken = "";
    global.gEmpresa = "";
    global.gOperador = "";
    global.gUpc = "";
    global.gDescripcionUpc = "";
    global.gDeterminante = "";
    global.gNombre = "";
    global.gDeterminanteDetalle = "";
    global.gInvt = "";
    global.gInve = "";
    global.gInvb = "";
    global.gComentarios = "";
    global.gMsg = "";
    global.gFoto1 = "";
    global.gFoto2 = "";
    global.gFoto3 = "";
    global.gFoto4= "";
    global.gFoto5 = "";
    global.gFoto6 = "";
    global.gFoto7 = "";
    global.gFoto8 = "";
    global.gFoto9 = "";
    global.gFoto10 = "";
    global.gFotoid = {};
    global.gFoto ="";
    global.gVerFoto ="";
    global.gMostrarFoto="no";
    global.gImagen64= "";
    global.gCheckbox = {};
    global.gCheckboxSeg = {};
    global.gCheckboxSegId = {};
    global.gGeo = null;
    global.gPantalla = "";
    global.gBeta = "";
    global.gObject;
    global.gWidth;
    global.gCarreteLleno = true;
    global.gTipoFoto = "";
    global.gVentaOb="";
    global.gVentaReal="";
    global.gVentaAv="";
    global.gExhibicionOb="";
    global.gExhibicionReal="";
    global.gExhibicionAv="";
    global.gVentaCeroTotal="";
    global.gVentaCeroReal="";
    global.gVentaCeroAv="";
    global.gVentaCeroOb="";
    global.gRutaTotal="";
    global.gRutaReal="";
    global.gRutaAv="";
    global.gRutaOb="";
    global.gDashboardTienda={};
    global.gLotescapturados={};
    global.gLote="";
    global.gTipoCapInv="";
    global.upcs=[];
    global.scanear=true;
    global.origenFoto="";
    global.gEstatusFactura="";
    global.gFolioFactura="";
    global.gFolioRecibo="";
    global.gMontoFactura=0.0;
    global.gFechaEmision="";
    global.gMonto = 0.0;
}




